export class GPTypeItem
{
    constructor () {
        this.typeName = "GPTypeItem"
    }

    static scaleAccordingToHorizon(projy, sizeY, horizonPos, designWidth, sizeX) {
        let sy = sizeY ? sizeY : GP.project.sizeY;
        let sx = sizeX ? sizeX : GP.project.sizeX;
        let hp = horizonPos ? horizonPos : GP.project.horizonPos;
        let dw = designWidth ? designWidth : GP.project.designWidth;
        let s = (projy - sy * (1 - hp)) * sx / (hp * sy * dw);
        return s;
    }

}